import React from "react";
import './ContactUs.css';
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTwitter, faInstagram, faFacebook, faYoutube } from '@fortawesome/free-brands-svg-icons'
import Iframe from 'react-iframe'
import { BUSINESS } from "../../config/business";

export default function ContactUs() {
    return (
        <div className="contactuscontainer">
            <Header />

            <div className="midbody">
                <div className="leftportion">
                    <div className="contact-card">
                        <h2>Our Contact Info</h2>

                        <p className="contact-label">Showroom</p>
                        <p className="contact-value">{BUSINESS.operatingAddress}</p>

                        <p className="contact-label">Registered address</p>
                        <p className="contact-value">{BUSINESS.registeredAddress}</p>

                        <p className="contact-label">Reach us</p>
                        <p className="contact-value">
                            <a href={`mailto:${BUSINESS.email}`}>{BUSINESS.email}</a>
                        </p>
                        <p className="contact-value">
                            <a href={`tel:+${BUSINESS.phoneRaw}`}>{BUSINESS.phone}</a>
                        </p>
                        <p className="contact-value">
                            <a
                                href={`https://wa.me/${BUSINESS.whatsapp}`}
                                target="_blank"
                                rel="noreferrer"
                            >
                                Chat on WhatsApp
                            </a>
                        </p>

                        <p className="contact-label">Support hours</p>
                        <p className="contact-value">{BUSINESS.supportHours}</p>

                        <div className="contact-social">
                            <a aria-label="Twitter" href="https://twitter.com/pdpro1/status/1568647764745277441" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faTwitter} size='lg' /></a>
                            <a aria-label="Instagram" href="https://www.instagram.com/rango_ecycles/" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faInstagram} size='lg' /></a>
                            <a aria-label="Facebook" href="https://www.facebook.com/rangoecyclespatna" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faFacebook} size='lg' /></a>
                            <a aria-label="YouTube" href="https://www.youtube.com/@rango_ecycles" target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faYoutube} size='lg' /></a>
                        </div>

                        <p className="contact-note">
                            For a complaint about an order, a payment or your personal
                            data, email us with your invoice number. We acknowledge every
                            complaint within 48 working hours and aim to resolve it within
                            15 working days.
                        </p>
                    </div>

                    <iframe
                        title="Rango E-Cycles showroom location"
                        className="contact-map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3597.7154305383747!2d85.03930817529535!3d25.614370677444803!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39ed57371edceb4d%3A0xb992254722adcdab!2sRango%20E-Cycles%20%7C%20Powered%20by%20EM%20%7C%20Bihar's%20First%20%7C%20EMotorad%20Exclusive%20Showroom!5e0!3m2!1sen!2sin!4v1727325905303!5m2!1sen!2sin"
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        allowFullScreen
                    ></iframe>
                </div>

                <div className="rightportion">
                    <Iframe
                        className="contact-form-frame"
                        title="Enquiry form"
                        src="https://docs.google.com/forms/d/e/1FAIpQLSepNRt2Hcr_xcqGovMGJ1jOazxhzdIwaV8LuyBs2PLl-yjb9A/viewform?usp=sf_link"
                        width="100%"
                        height="650"
                        frameBorder="0"
                    >
                        Loading…
                    </Iframe>
                    <p className="contact-consent">
                        By submitting this form you consent to us contacting you about
                        your enquiry. See our{" "}
                        <a href="/privacy">Privacy Policy</a> for how we handle your
                        details.
                    </p>
                </div>
            </div>

            <Footer />
        </div>
    )
}
